module.exports = __webpack_public_path__ + "img/cafe.6999197a.svg";